/// <amd-module name="Artifacts/Connect/tools/python/Pip" />
import { CopyableCode, DetailsCard } from "Artifacts/Connect/components/Common";
import * as Res from "Artifacts/Connect/Resources";
import { PackagingService, TfsService } from "Artifacts/Connect/services/PackagingService";
import { ToolService } from "Artifacts/Connect/services/ToolService";
import { IToolConnectProps } from "Artifacts/Connect/tools/IToolConnectProps";
import { PythonProtocol } from "Artifacts/Connect/tools/python/Protocol";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { ITool, ToolId } from "Artifacts/Connect/types/ITool";
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData } from "VSS/Platform/Page";
import { Link } from "VSSUI/Link";

const PipConnect: React.FC<IToolConnectProps<PythonProtocol>> = ({
  protocol,
  feed: feed,
  packagingService,
}) => {
  const feedUrl = protocol.getFeedUrl(packagingService, feed);

  return (
    <React.Fragment>
      <DetailsCard title={{ text: Res.ProjectSetup, ariaLevel: 3 }}>
        <FormatComponent format={Res.ProjectSetup_CredProvider}>
          <b>{Res.ArtifactsKeyring}</b>
          <b>{Res.ArtifactsKeyring}</b>
        </FormatComponent>
        <p>
          <FormatComponent format={Res.ProjectSetup_Pip_VirtualEnv}>
            <Link
              href="https://go.microsoft.com/fwlink/?linkid=2103878"
              target="_blank"
              rel="nofollow noreferrer noopener help"
              underline
            >
              {Res.TheseInstructions}
            </Link>
          </FormatComponent>
        </p>

        <p>
          <FormatComponent format={Res.Pip_Config}>
            <code>pip.ini</code>
            <code>pip.conf</code>
          </FormatComponent>
        </p>
        <CopyableCode ariaLabel={Res.ProjectSetup}>
          <pre>{`[global]
index-url=${feedUrl}`}</pre>
        </CopyableCode>
      </DetailsCard>

      <DetailsCard title={{ text: Res.InstallPackages, ariaLevel: 3 }}>
        <p>{Res.RunCommand_Directory}</p>
        <CopyableCode ariaLabel={Res.InstallPackages}>pip install</CopyableCode>
      </DetailsCard>
    </React.Fragment>
  );
};

class PipTool implements ITool {
  readonly id = ToolId.pip;
  readonly name = "pip";
  readonly protocol = new PythonProtocol();
  readonly allowNonMembers = true;
  readonly imagePath = `ms.azure-artifacts/connect/img/pip.svg`;
  readonly toolLinkId = 2103690;
  readonly Component: React.ComponentType = PipConnect;

  isEnvironmentSupported(pageData: IPageData): boolean {
    return true;
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }

  supportsGet(): boolean {
    return true;
  }

  supportsPush(feed: ICombinedFeedView): boolean {
    return feed.canPublishPackages;
  }

  renderComponent(
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    packagingService: PackagingService,
    tfsService: TfsService,
  ): JSX.Element {
    return (
      <PipConnect
        pageContext={pageContext}
        protocol={this.protocol}
        feed={feed}
        packagingService={packagingService}
        tfsService={tfsService}
      />
    );
  }

  public getToolLink = () => ({
    href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
    children: `${Res.CommandLineReference}`,
  });
}

ToolService.registerTool(new PipTool());
